import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Es seguro seguir estas recetas?',
  answer: 'Sí, absolutamente. Todas las recetas están diseñadas basándose en principios nutricionales comprobados para la salud hepática, utilizando ingredientes naturales, enteros y antiinflamatorios.'
}, {
  question: '¿En qué formato recibiré el recetario?',
  answer: 'Es un producto 100% digital en formato PDF de alta calidad. Podrás descargarlo inmediatamente después de tu compra y leerlo en tu celular, tablet o computadora, o imprimirlo si lo prefieres.'
}, {
  question: '¿Funciona para todos los grados de hígado graso?',
  answer: 'Las recetas son beneficiosas para cualquier persona que busque mejorar su salud hepática. Sin embargo, si tienes una condición médica avanzada, siempre recomendamos consultar con tu médico tratante.'
}, {
  question: '¿Cuánto tiempo tardaré en ver resultados?',
  answer: 'Muchos de nuestros clientes reportan sentir más energía y menos inflamación en la primera semana. Los cambios en los análisis de sangre suelen verse después de 4 a 8 semanas de seguir el plan consistentemente.'
}, {
  question: '¿Los ingredientes son difíciles de conseguir o caros?',
  answer: 'No. Hemos diseñado las recetas pensando en la accesibilidad. Todos los ingredientes los puedes encontrar en tu supermercado local o mercado de confianza, sin gastar una fortuna.'
}, {
  question: '¿Cómo funciona la garantía de reembolso?',
  answer: 'Tienes 60 días completos para probar las recetas. Si sientes que no te han ayudado o simplemente no te gustan, nos envías un correo y te devolveremos el 100% de tu dinero, sin hacer preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-brand-bg" data-id="element-36">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-37">
        <div className="text-center mb-12" data-id="element-38">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-39">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-gray-600" data-id="element-40">
            Resolvemos tus dudas para que tomes la mejor decisión.
          </p>
        </div>

        <div className="space-y-4" data-id="element-41">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className={`bg-white rounded-2xl border transition-colors duration-200 overflow-hidden ${isOpen ? 'border-brand-accent' : 'border-gray-200'}`} data-id="element-42">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent focus-visible:ring-inset" aria-expanded={isOpen} data-id="element-43">
                  <span className="font-bold text-gray-900 pr-4" data-id="element-44">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-primary transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-45" />
                </button>

                <AnimatePresence data-id="element-46">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-47">
                      <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-48">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}